import React from 'react';
import { faqs } from '../data/mockData';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
            <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">FAQ</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-5">
              Common Questions, Clear Answers
            </h2>
            <p className="text-base text-[#4B5563] leading-relaxed">
              Everything you need to know about trademark registration, pricing, and our process.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible>
              {faqs.map((faq) => (
                <AccordionItem
                  key={faq.id}
                  value={`item-${faq.id}`}
                  data-testid={`faq-item-${faq.id}`}
                  className="border-b border-[#E5E7EB]"
                >
                  <AccordionTrigger className="text-left text-sm font-bold text-[#0A0F1C] hover:text-[#002FA7] py-6 transition-colors duration-300">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-[#4B5563] leading-relaxed pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
